<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-row :gutter="24">
        <!-- 部门树暂时隐藏
        <a-col :span="4">
          <dept-tree ref="deptTree" :deptOptions="deptOptions" @select="clickDeptNode" />
        </a-col>
        -->
        <a-col :span="24">
          <div class="table-page-search-wrapper">
            <a-form layout="inline">
              <a-row :gutter="48">
                <a-col :md="8" :sm="24">
                  <a-form-item :label="$t('views.systemUser.query.userName')">
                    <a-input v-model="queryParam.userName" :placeholder="$t('views.systemUser.query.userNamePlaceholder')" allow-clear />
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24">
                  <a-form-item :label="$t('views.systemUser.query.phoneNumber')">
                    <a-input v-model="queryParam.phoneNumber" :placeholder="$t('views.systemUser.query.phoneNumberPlaceholder')" allow-clear />
                  </a-form-item>
                </a-col>
                <template v-if="advanced">
                  <a-col :md="8" :sm="24">
                    <a-form-item :label="$t('views.systemUser.query.status')" prop="status">
                      <a-select v-model="queryParam.status" :placeholder="$t('views.systemUser.query.statusPlaceholder')" style="width: 100%" allow-clear>
                        <a-select-option
                          v-for="(d, index) in localizedStatusOptions"
                          :key="index"
                          :value="d.value">{{ d.label }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="8" :sm="24">
                    <a-form-item :label="$t('views.systemUser.query.createTime')">
                      <a-range-picker
                        style="width: 100%"
                        v-model="dateRange"
                        valueFormat="YYYY-MM-DD"
                        format="YYYY-MM-DD"
                        allow-clear />
                    </a-form-item>
                  </a-col>
                </template>
                <a-col :md="!advanced && 8 || 24" :sm="24">
                  <span
                    class="table-page-search-submitButtons"
                    :style="advanced && { float: 'right', overflow: 'hidden' } || {}">
                    <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('views.systemUser.btn.query') }}</a-button>
                    <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('views.systemUser.btn.reset') }}</a-button>
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <div class="table-operations">
            <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['system:user:add']">
              <a-icon type="plus" />{{ $t('views.systemUser.btn.add') }}
            </a-button>
            <a-button
              type="primary"
              :disabled="single"
              @click="$refs.createForm.handleUpdate(undefined, ids)"
              v-hasPermi="['system:user:edit']">
              <a-icon type="edit" />{{ $t('views.systemUser.btn.edit') }}
            </a-button>
            <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['system:user:remove']">
              <a-icon type="delete" />{{ $t('views.systemUser.btn.delete') }}
            </a-button>
            <a-button
              type="dashed"
              @click="$refs.importExcel.importExcelHandleOpen()"
              v-hasPermi="['system:user:import']">
              <a-icon type="import" />{{ $t('views.systemUser.btn.import') }}
            </a-button>
            <table-setting
              :style="{ float: 'right' }"
              :table-size.sync="tableSize"
              v-model="columns"
              :refresh-loading="loading"
              @refresh="getList" />
          </div>
          <create-form
            ref="createForm"
            :deptOptions="deptOptions"
            :statusOptions="dict.type['sys_normal_disable']"
            :sexOptions="dict.type['sys_user_sex']"
            @ok="getList"
            @select-tree="getTreeselect" />
          <reset-password ref="resetPassword" />
          <auth-role ref="authRole" />
          <import-excel ref="importExcel" @ok="getList" />
          <a-table
            :loading="loading"
            :size="tableSize"
            rowKey="id"
            :columns="displayColumns"
            :data-source="list"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            :pagination="false"
            :bordered="tableBordered">

            <a-switch slot="status" slot-scope="text, record" :checked="record.status === 1 " @change="changeSwitch($event,record)" />
            <span slot="createTime" slot-scope="text, record">
              {{ parseTime(record.createTime) }}
            </span>
            <span slot="operation" slot-scope="text, record" v-if="record.id !== 1">
              <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['system:user:edit']">
                <a-icon type="edit" />
                {{ $t('views.systemUser.btn.edit') }}
              </a>
              <a-divider type="vertical" v-hasPermi="['system:user:remove']" />
              <a @click="handleDelete(record)" v-hasPermi="['system:user:remove']">
                <a-icon type="delete" />
                {{ $t('views.systemUser.btn.delete') }}
              </a>
              <a-divider type="vertical" v-hasPermi="['system:user:edit']" />
              <a-dropdown v-hasPermi="['system:user:edit']">
                <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                  <a-icon type="double-right" />
                  {{ $t('views.systemUser.btn.more') }}
                </a>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a @click="$refs.resetPassword.handleResetPwd(record)">
                      <a-icon type="key" />
                      {{ $t('views.systemUser.action.resetPassword') }}
                    </a>
                  </a-menu-item>
                  <a-menu-item >
                    <a @click="$refs.authRole.handleAuthRole(record)">
                      <a-icon type="check-circle" />
                      {{ $t('views.systemUser.action.assignRole') }}
                    </a>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </span>
          </a-table>
          <a-pagination
            class="ant-table-pagination"
            show-size-changer
            show-quick-jumper
            :current="queryParam.pageNum"
            :total="total"
            :page-size="queryParam.pageSize"
            :showTotal="showPaginationTotal"
            @showSizeChange="onShowSizeChange"
            @change="changeSize" />
        </a-col>
      </a-row>
    </a-card>
  </page-header-wrapper>
</template>

<script>

import { pageUser, delUser, changeUserStatus, deptTreeSelect } from '@/api/system/user'
import AuthRole from './modules/AuthRole'
import ResetPassword from './modules/ResetPassword'
import CreateForm from './modules/CreateForm'
import ImportExcel from './modules/ImportExcel'
import DeptTree from './modules/DeptTree'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'User',
  components: {
    AuthRole,
    ResetPassword,
    CreateForm,
    ImportExcel,
    DeptTree
  },
  mixins: [tableMixin],
  dicts: ['sys_normal_disable', 'sys_user_sex'],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      advanced: false,
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      deptOptions: [{
        id: 0,
        label: '',
        children: []
      }],
      dateRange: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        userName: undefined,
        phoneNumber: undefined,
        status: undefined,
        deptId: undefined
      },
      columns: [
        {
          title: '',
          dataIndex: 'id',
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'userName',
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'phoneNumber',
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'nickName',
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'dept.deptName',
          scopedSlots: { customRender: 'dept.deptName' },
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  created() {
    this.getList()
    this.getDeptTree()
  },
  computed: {
    localizedStatusOptions () {
      return this.localizeDictOptions(this.dict.type['sys_normal_disable'], 'views.systemUser.dict.status')
    },
    displayColumns() {
      const titleKeyByDataIndex = {
        id: 'views.systemUser.column.id',
        userName: 'views.systemUser.column.userName',
        phoneNumber: 'views.systemUser.column.phoneNumber',
        nickName: 'views.systemUser.column.nickName',
        'dept.deptName': 'views.systemUser.column.dept',
        status: 'views.systemUser.column.status',
        createTime: 'views.systemUser.column.createTime',
        operation: 'views.systemUser.column.operation'
      }
      return this.columns.map(col => {
        const key = titleKeyByDataIndex[col.dataIndex]
        return {
          ...col,
          title: key ? this.$t(key) : col.title
        }
      })
    }
  },
  methods: {
    localizeDictOptions (options, keyPrefix) {
      return (options || []).map(item => {
        const i18nKey = `${keyPrefix}.${item.value}`
        return {
          ...item,
          label: this.$te(i18nKey) ? this.$t(i18nKey) : item.label
        }
      })
    },
    showPaginationTotal(total) {
      return this.$t('views.systemUser.pagination.total', { total })
    },
    changeSwitch(e, record) {
      this.confirmHandleStatus(record)
    },
    getTreeselect() { },
    getList() {
      this.loading = true
      pageUser(this.addDateRange(this.queryParam, this.dateRange)).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    getDeptTree() {
      deptTreeSelect().then(response => {
        this.deptOptions = response.data
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.dateRange = []
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        userName: undefined,
        phoneNumber: undefined,
        status: undefined,
        deptId: undefined
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    clickDeptNode(deptId) {
      this.queryParam.deptId = deptId
      this.handleQuery()
    },
    confirmHandleStatus(row) {
      const oldStatus = row.status
      const action = row.status === 0
        ? this.$t('views.systemUser.status.enable')
        : this.$t('views.systemUser.status.disable')
      const status = row.status === 1 ? 0 : 1
      changeUserStatus(row.id, status).then((res) => {
        if (res.success) {
          row.status = status
          this.$message.success(this.$t('views.systemUser.msg.statusSuccess', { action }), 3)
        } else {
          row.status = oldStatus
          this.$message.error(this.$t('views.systemUser.msg.statusFail', { action, message: res.message }), 3)
        }
      }).catch(() => {
        this.$message.error(this.$t('views.systemUser.msg.statusException', { action }), 3)
      })
    },
    handleDelete(row) {
      const that = this
      const userIds = row.id || this.ids
      this.$confirm({
        title: this.$t('views.systemUser.confirm.deleteTitle'),
        content: this.$t('views.systemUser.confirm.deleteContent', { ids: userIds }),
        onOk() {
          return delUser(userIds)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(that.$t('views.systemUser.msg.deleteSuccess'), 3)
            })
        },
        onCancel() { }
      })
    },
    handleExport() {
      const that = this
      this.$confirm({
        title: this.$t('views.systemUser.confirm.exportTitle'),
        content: this.$t('views.systemUser.confirm.exportContent'),
        onOk() {
          that.download('system/user/export', {
            ...that.queryParam
          }, `user_${new Date().getTime()}.xlsx`)
        },
        onCancel() { }
      })
    }
  }
}
</script>
